import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Button, Group, Modal, TextInput, PasswordInput, Text } from '@mantine/core';

import { useSignUpManager } from '../api/signUpManager';
import { useManagerForm } from '../hooks/useManagerForm';

import { Departments } from '@/types';

type Props = {
  department: Departments;
};

export const AddModal = NiceModal.create(({ department }: Props) => {
  const modal = useModal();
  const form = useManagerForm();

  const { mutate, isLoading } = useSignUpManager({ config: { onSuccess: modal.remove } });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={modal.remove}
      title={`New manager (${department.toUpperCase()})`}
    >
      <form
        onSubmit={form.onSubmit(({ username, password, email }) =>
          mutate({
            username,
            password,
            email: email.trim() || undefined,
            department,
          })
        )}
      >
        <Text mt="sm" mb="xs" size="sm">
          Username
        </Text>
        <TextInput
          autoComplete="off"
          required
          placeholder="Username"
          value={form.values.username}
          onChange={(event) => form.setFieldValue('username', event.currentTarget.value)}
          mb="xl"
          error={form.errors.username}
        />
        <Text mb="xs" size="sm">
          Email
        </Text>
        <TextInput
          autoComplete="off"
          placeholder="Email"
          value={form.values.email}
          onChange={(event) => form.setFieldValue('email', event.currentTarget.value)}
          mb="xl"
          error={form.errors.email}
        />
        <Text mb="xs" size="sm">
          Password
        </Text>
        <PasswordInput
          required
          placeholder="Password"
          value={form.values.password}
          onChange={(event) => form.setFieldValue('password', event.currentTarget.value)}
          mb="xl"
          error={form.errors.password}
        />
        <Group justify="right">
          <Button loading={isLoading} type="submit">
            Add
          </Button>
        </Group>
      </form>
    </Modal>
  );
});
